/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Function to drag and drop
// Get the container
const list = document.getElementById('list');
if (!list) throw new Error('#list element not found');

if (window.serverSavedOrder && typeof window.serverSavedOrder === 'string') {
  const ids = window.serverSavedOrder.split('|').filter(Boolean);
  if (ids.length) {
    const map = Array.from(document.querySelectorAll('#list .iwishItem')).reduce((m, el) => {
      if (el.dataset && el.dataset.id) m[el.dataset.id] = el;
      return m;
    }, {});
    ids.forEach(id => {
      if (map[id]) list.appendChild(map[id]);
    });
  }
}

function updateIndexesInternal() {
  const items = Array.from(document.querySelectorAll('#list .iwishItem'));
  items.forEach((item, idx) => {
    item.dataset.position = String(idx + 1); // 1-based index
  });
}

function saveEachItemSingleId(sendDataId = false) {
  const items = Array.from(document.querySelectorAll('#list .iwishItem'));

  items.forEach((item, idx) => {
    try {
      const btn = item.querySelector('.iwishRemoveBtn');
      if (!btn) return;

      const pId = btn.getAttribute('data-product');
      const vId = btn.getAttribute('data-variant');

      const itemDataId = item.dataset.id;
      const itemPosition = item.dataset.position || (idx + 1);

      if (!pId || !vId) return;

      if (typeof iWish !== 'undefined' && typeof iWish.updateWishlist === 'function') {
        const s_order = sendDataId ? itemDataId : itemPosition;
        iWish.updateWishlist(pId, vId, null, null, s_order);
        console.log("Saved:", { pId, vId, s_order });
      } else {
        console.warn('iWish.updateWishlist not available; cannot save order to server.');
      }
    } catch (err) {
      console.error("Error saving item", err);
    }
  });
}

// --- Sortable toggle logic (disable on mobile) ---
let sortableInstance = null;
const MOBILE_MAX_WIDTH = 767; 

function isMobileViewport() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
}

function createSortable() {
  // avoid creating twice
  if (sortableInstance) return;

  sortableInstance = Sortable.create(list, {
    onEnd: function (evt) {
      console.log("Moved from:", evt.oldIndex, "to:", evt.newIndex, "-> pos:", evt.newIndex + 1);
      updateIndexesInternal();
      // send numeric index to server
      saveEachItemSingleId(false);
    }
  });

  //console.log('Sortable enabled (desktop view).');
}

function destroySortable() {
  if (!sortableInstance) return;
  try {
    if (typeof sortableInstance.destroy === 'function') {
      sortableInstance.destroy();
    } else if (typeof sortableInstance.option === 'function') {
      sortableInstance.option('disabled', true);
    }
  } catch (err) {
    console.warn('Error destroying sortable instance:', err);
  }
  sortableInstance = null;
  //console.log('Sortable disabled (mobile view).');
}

function toggleSortableBasedOnViewport() {
  if (isMobileViewport()) {
    destroySortable();
    updateIndexesInternal();
  } else {
    createSortable();
    updateIndexesInternal();
  }
}

// initialize on load
document.addEventListener('DOMContentLoaded', function () {
  toggleSortableBasedOnViewport();
});

let resizeTimer = null;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    toggleSortableBasedOnViewport();
  }, 150); // 150ms debounce — adjust if you like
});



// On Load value changes of input field
// let sortableInstance;

// function initSortable() {
//     const list = document.getElementById('list');
//     if (window.innerWidth > 768) {
//         if (!sortableInstance) {
//             sortableInstance = Sortable.create(list, {
//                 group: "localStorage-example",
//                 store: {
//                     get: function (sortable) {
//                         const order = localStorage.getItem(sortable.options.group.name);
//                       console.log(order);
//                         return order ? order.split('|') : [];
//                     },
//                     set: function (sortable) {
//                         const order = sortable.toArray();
//                         localStorage.setItem(sortable.options.group.name, order.join('|'));
//                     }
//                 },
//                 onEnd: function (evt) {
//                     console.log('Item moved:', evt.item);
//                 }
//             });
//         }
//     } else {
//         if (sortableInstance) {
//             //sortableInstance.destroy();
//             sortableInstance = null;
//         }
//     }
// }

// // Call the function to initialize
// initSortable();

// Function to initialize the sortable list
// const groupName = "localStorage-example";
// let sortableInstance;

// // Helper: get current s_order from DOM (data-id sequence)
// const getCurrentSOrder = (list) => {
//   return Array.from(list.querySelectorAll('.iwishItem'))
//     .map(it => it.dataset.id)
//     .filter(Boolean)
//     .join('|');
// };

// // Build wishlist array
// const buildWishlistData = (list) => {
//   return Array.from(list.querySelectorAll('.iwishItem')).map(item => {
//     const removeBtn = item.querySelector('.iwishRemoveBtn');
//     const pId = removeBtn ? removeBtn.getAttribute('data-product') : item.dataset.product;
//     const vId = removeBtn ? removeBtn.getAttribute('data-variant') : item.dataset.id;
//     //const qtyInput = item.querySelector('.input-quantity') || item.querySelector('.iwishQtyInput');
//     //const qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
//     if (!pId || !vId) return null;
//     return { pId, vId };
//   }).filter(Boolean);
// };

// // Persist s_order to localStorage
// const saveOrderLocally = (orderString) => {
//   if (!orderString) return;
//   localStorage.setItem(groupName, orderString);
// };

// const applyOrderToDOM = (orderString) => {
//   if (!orderString) return;
//   const list = document.getElementById('list');
//   if (!list) return;
//   const ids = orderString.split('|').filter(Boolean);
//   // quick map of id -> element for speed
//   const map = Array.from(list.querySelectorAll('.iwishItem')).reduce((acc, el) => {
//     if (el.dataset.id) acc[el.dataset.id] = el;
//     return acc;
//   }, {});
//   ids.forEach(id => {
//     const el = map[id];
//     if (el) list.appendChild(el);
//   });
// };

// const updateWishlistWithOrder = () => {
//   const list = document.getElementById('list');
//   if (!list) return;

//   const listItems = Array.from(list.querySelectorAll('.iwishItem'));
//   if (!listItems.length) return;

//   // Build wishlist data (each has pId, vId, and its own s_order)
//   const wishlistData = listItems.map(item => {
//     const removeBtn = item.querySelector('.iwishRemoveBtn');
//     if (!removeBtn) return null;

//     const pId = removeBtn.getAttribute('data-product');
//     const vId = removeBtn.getAttribute('data-variant');
//     const s_order = item.dataset.id;       

//     if (!pId || !vId || !s_order) return null;
//     return { pId, vId, s_order };
//   }).filter(Boolean);

//   if (!wishlistData.length) return;

//   const idList = wishlistData.map(x => x.s_order).join('|');
//   localStorage.setItem(groupName, idList);

//   // Send updateWishlist per item
//   if (typeof iWish !== 'undefined' && typeof iWish.updateWishlist === 'function') {

//     wishlistData.forEach(item => {
//       try {
//         iWish.updateWishlist(item.pId, item.vId, null, null, item.s_order);
//         console.log("updateWishlist →", {
//           pId: item.pId,
//           vId: item.vId,
//           s_order: item.s_order  
//         });
//       } catch (err) {}
//     });

//   } else {
//     console.warn("iWish.updateWishlist missing.");
//   }

//   console.log("Done — saved s_order per product", wishlistData);
// };

// // Initialize Sortable WITHOUT adding data-order
// const initSortable = () => {
//   const list = document.getElementById('list');
//   if (!list) return;
//   if (window.innerWidth > 768) {
//     if (!sortableInstance) {
//       sortableInstance = Sortable.create(list, {
//         group: groupName,
//         dataIdAttr: 'data-id', 
//         onEnd: () => {
//           if (typeof updateWishlistWithOrder === 'function') {
//             updateWishlistWithOrder();
//           }
//         }
//       });
//     }
//   } else {
//     // destroy Sortable on small screens (if created)
//     if (sortableInstance) {
//       sortableInstance.destroy();
//       sortableInstance = null;
//     }
//   }
// };


// document.addEventListener('DOMContentLoaded', () => {
//   const list = document.getElementById('list');
//   if (!list) return;

//   const saved = localStorage.getItem(groupName);
//   if (saved) applyOrderToDOM(saved);

//   // initialize sort and then sync once
//   initSortable();
//   updateWishlistWithOrder();
// });

// window.addEventListener('resize', initSortable);





// // on load zero and localstorage save value on page refresh       
document.addEventListener("DOMContentLoaded", function () {

  const intervalId1 = setInterval(function () {
    const newselects = document.querySelectorAll('.iwishItem .input-quantity');

    if (!newselects.length) return;

    newselects.forEach(inputElement => {
      if (inputElement.dataset.init === "1") return;
      inputElement.dataset.init = "1";

      const iwishItem = inputElement.closest('.iwishItem');
      const iwishProQtyElement = iwishItem?.querySelector('.iwishQtyInput');
      if (!iwishProQtyElement) return;

      const inputVId = iwishProQtyElement.dataset.variant;
      const step = parseInt(inputElement.getAttribute("step")) || 1;

      let wishlistData = JSON.parse(localStorage.getItem("iwish_list")) || [];
      let foundIndex = wishlistData.findIndex(([id]) => id == inputVId);

      let storedQty = foundIndex > -1 ? wishlistData[foundIndex][1] : 0;

       if (storedQty === null || storedQty === 1) {
            storedQty = 0;
            if (foundIndex > -1) {
              wishlistData[foundIndex][1] = storedQty;
            } else {
              wishlistData.push([inputVId, storedQty]);
            }
            localStorage.setItem("iwish_list", JSON.stringify(wishlistData));
          }
          storedQty = Math.round(storedQty / step) * step;
          //console.log(storedQty, 'Storedqty')
          inputElement.value = storedQty;
          iwishProQtyElement.value = storedQty;

          inputElement.addEventListener('change', function () {
            let newQty = Math.round((parseInt(inputElement.value) || 0) / step) * step;
            inputElement.value = newQty;
            iwishProQtyElement.value = newQty;

            let data = JSON.parse(localStorage.getItem("iwish_list")) || [];
            const idx = data.findIndex(([id]) => id == inputVId);

            if (idx > -1) data[idx][1] = newQty;
            else data.push([inputVId, newQty]);

            localStorage.setItem("iwish_list", JSON.stringify(data));
          });
          if (typeof iWish !== 'undefined' && iWish.setWishlist) {
            iWish.setWishlist();
          }
    });

  }, 500);
});

/* ================= RESTORE FUNCTION ================= */
// function restoreWishlistQuantities() {

//   const wait = setInterval(() => {
//     const inputs = document.querySelectorAll('.iwishMeta-price .input-quantity');
//     if (!inputs.length) return;

//     clearInterval(wait);

//     let wishlistData = JSON.parse(localStorage.getItem("iwish_list")) || [];

//     inputs.forEach(inputElement => {
//       const iwishItem = inputElement.closest('.iwishItem');
//       const hiddenQty = iwishItem?.querySelector('.iwishQtyInput');
//       if (!hiddenQty) return;

//       const variantId = hiddenQty.getAttribute("data-variant");
//       const step = parseInt(inputElement.getAttribute("step")) || 1;

//       const foundIndex = wishlistData.findIndex(([id]) => id == variantId);
//       let storedQty = foundIndex > -1 ? wishlistData[foundIndex][1] : null;

//        if (storedQty === null || storedQty === 1) {
//             storedQty = 0;
//             if (foundIndex > -1) {
//               wishlistData[foundIndex][1] = storedQty;
//             } else {
//               wishlistData.push([inputVId, storedQty]);
//             }
//             localStorage.setItem("iwish_list", JSON.stringify(wishlistData));
//           }
      
//       storedQty = Math.round(storedQty / step) * step;
//       console.log(storedQty, 'Storedqty')
//       inputElement.value = storedQty;
//       hiddenQty.value = storedQty;

//       /* ===== save qty when user changes it ===== */
//       inputElement.addEventListener("change", function () {
//         let qty = parseInt(inputElement.value) || 0;
//         qty = Math.round(qty / step) * step;

//         inputElement.value = qty;
//         hiddenQty.value = qty;

//         let wishlistData = JSON.parse(localStorage.getItem("iwish_list")) || [];
//         const idx = wishlistData.findIndex(([id]) => id == variantId);

//         if (idx > -1) wishlistData[idx][1] = qty;
//         else wishlistData.push([variantId, qty]);

//         localStorage.setItem("iwish_list", JSON.stringify(wishlistData));
//       });
//     });
//   }, 300);
// }


// /* ================= PAGE LOAD ================= */
// document.addEventListener("DOMContentLoaded", restoreWishlistQuantities);
// document.addEventListener("click", function (e) {
//   const pageLink = e.target.closest('.iwishPagination a[data-page]');
//   if (!pageLink) return;

//   // wait for iWish to reload wishlist content
//   setTimeout(() => {
//     restoreWishlistQuantities();
//   }, 600);
// });



/* ADD TO CART  */
document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  if (!addToCartBtn) return;

  addToCartBtn.addEventListener("click", function () {

    let wishlistData = JSON.parse(localStorage.getItem("iwish_list")) || [];
    const products = [];

    // Loop over each unique product
    document.querySelectorAll('.iwishItem').forEach(item => {
      const skuEl = item.querySelector('.prd_sku');
      const hiddenQty = item.querySelector('.iwishQtyInput'); // hidden qty
      const qtyInputs = item.querySelectorAll('.input-quantity'); // desktop + mobile

      if (!skuEl || !hiddenQty || !qtyInputs.length) return;

      const qty = Number(hiddenQty.value) || 0;
      const variantId = hiddenQty.dataset.variant;
      const sku = skuEl.innerHTML.trim();

      //  Send only products with qty > 0
      if (qty > 0) {
        products.push({
          sku,
          absoluteQuantity: qty
        });
      }

      // Reset UI (desktop + mobile + hidden)
      qtyInputs.forEach(input => (input.value = 0));
      hiddenQty.value = 0;

      // Update localStorage to reflect reset
      const idx = wishlistData.findIndex(([id]) => id == variantId);
      if (idx > -1) {
        wishlistData[idx][1] = 0;
      } else {
        wishlistData.push([variantId, 0]);
      }
    });

    // Save updated wishlistData
    localStorage.setItem("iwish_list", JSON.stringify(wishlistData));
    //console.log("Products sent to cart:", products);

    if (!products.length) return;

    // Send to cart
    window.spark.updateCart({ products });
  });
});


// On change of input field
 const intervalId1 = setInterval(function() {
  const elements1 = document.querySelectorAll('.iwishMeta-price .input-quantity');
  if (elements1.length > 0) {
    clearInterval(intervalId1);
    elements1.forEach(quantityInput => {
      const iwishProQtyElements = quantityInput.closest('.iwishItem')?.querySelector('.iwishQtyInput');
      if (iwishProQtyElements) {
        quantityInput.addEventListener('input', () => {
          const iWishvarId = quantityInput.closest('.iwishItem')?.querySelector('[name=id]').value;
          const newQty = parseInt(quantityInput.value) || 0;
          iwishProQtyElements.value = newQty;

          const pId = iwishProQtyElements.getAttribute('data-product');

          if (typeof iWish !== 'undefined' && typeof iWish.updateWishlist === 'function') {
            console.log('Quantity change: updateWishlist', pId, iWishvarId, newQty);
            iWish.updateWishlist(pId, iWishvarId, newQty);
          }

          //  if (typeof iWishAddFn !== 'undefined' && typeof iWishAddFn === 'function') {
          //     iWishAddFn(iWishvarId);
          //   }
        });
      }
    });
  }
}, 200);


// on click event
// Works with pagination / ajax reload
document.addEventListener("click", function (e) {
      const btn = e.target.closest(".btn-quantity-selector");
      if (!btn) return;
      const item = btn.closest(".iwishItem");
      if (!item) return;
      const qtyInputs = item.querySelectorAll(".input-quantity");
      const hiddenQty = item.querySelector(".iwishQtyInput");
      if (!qtyInputs.length || !hiddenQty) return;
      const step = parseInt(qtyInputs[0].getAttribute("step")) || 1;
      const variantId = hiddenQty.dataset.variant;

      let current = parseInt(hiddenQty.value) || 0;

      let newQty = btn.classList.contains("btn-plus")
        ? current + step
        : Math.max(0, current - step);
      qtyInputs.forEach(input => {
        input.value = newQty;
      });

      hiddenQty.value = newQty;
      let data = JSON.parse(localStorage.getItem("iwish_list")) || [];
      const idx = data.findIndex(([id]) => id == variantId);
      if (idx > -1) {
        data[idx][1] = newQty;
      } else {
        data.push([variantId, newQty]);
      }
      localStorage.setItem("iwish_list", JSON.stringify(data));

      // // Optional: notify iWish
      // if (typeof iWish !== "undefined" && iWish.setWishlist) {
      //   iWish.setWishlist();
      // }

     // console.log("Qty updated:", newQty);
});



// Function to add all items to cart
// document.addEventListener('DOMContentLoaded', function () {
//     const addToCartBtn = document.querySelector('[data-add-to-cart]');
//     if (!addToCartBtn) {
//         console.warn('No element with [data-add-to-cart] found!');
//         return;
//     }

//     addToCartBtn.addEventListener('click', function () {

//         const products = [];

//         document.querySelectorAll('.input-quantity').forEach(function (quantityInputs) {
//             const skuElement = quantityInputs.closest('.iwishItem')?.querySelector('.prd_sku');
//             const skus = skuElement ? skuElement.innerHTML.trim() : null;

//             const quantityValue = Number(quantityInputs.value) || 0;

//             if (skus && quantityValue > 0) {
//                 products.push({
//                     sku: skus,
//                     absoluteQuantity: quantityValue,
//                 });
//             }
//         });

//         console.log("Filtered products array:", products);

//         if (!products.length) return;

//         const pro = { products };

//         // ---- ADD TO CART ----
//         window.spark.updateCart(pro);

//         // ---- RESET UI + LOCAL STORAGE SAFELY ----
//         setTimeout(() => {
//             let wishlist = JSON.parse(localStorage.getItem('iwish_list')) || [];

//             document.querySelectorAll('.iwishItem').forEach(item => {
//                 const qtyInput = item.querySelector('.input-quantity');
//                 const hiddenQty = item.querySelector('.iwishQtyInput');

//                 if (!qtyInput || !hiddenQty) return;

//                 qtyInput.value = 0;
//                 hiddenQty.value = 0;

//                 // find variant stored in iwish
//                 const variantId = hiddenQty.getAttribute('data-variant');

//                 const index = wishlist.findIndex(([id]) => id == variantId);
//                 if (index > -1) {
//                     wishlist[index][1] = 0;   // set qty zero safely
//                 }
//             });

//             localStorage.setItem('iwish_list', JSON.stringify(wishlist));
//         }, 400); // safe cart delay
//     });
// });

// Function to add all items to cart document.addEventListener('DOMContentLoaded', function() { const addToCartBtn = document.querySelector('[data-add-to-cart]'); if (addToCartBtn) { addToCartBtn.addEventListener('click', function() { const products = []; document.querySelectorAll('.input-quantity').forEach(function (quantityInputs) { const skuElement = quantityInputs.closest('.iwishItem')?.querySelector('.prd_sku'); const skus = skuElement ? skuElement.innerHTML.trim() : null; const quantityValue = Number(quantityInputs.value) || 0; if (skus && quantityValue > 0) { products.push({ sku: skus, absoluteQuantity: quantityValue, }); } }); console.log("Filtered products array:", products); if (products.length > 0) { const pro = { products }; window.spark.updateCart(pro); document.querySelectorAll('.input-quantity').forEach(function (quantityInputs) { quantityInputs.value = 0; }); localStorage.setItem('iwish_list', JSON.stringify({})); } }); } else { console.warn('No element with [data-add-to-cart] found!'); } });

// Price and quantity increase and decrease based on quantity changes 
const intervalId5 = setInterval(() => {
  const elements5 = document.querySelectorAll('.quantity-selector-wrapper .input-quantity');
  if (elements5.length) {
    clearInterval(intervalId5);
    elements5.forEach(quantityInputs1 => {
      const root = quantityInputs1.closest('.iwishItem, .trnsferdeletedesk, .trnsfermob');
      const productEl = root ? root.querySelector('[data-product]') : document.querySelector('[data-product]');
      const parentProductId = productEl ? productEl.getAttribute('data-product') : null;
      const skuElement = root ? root.querySelector('.prd_sku') : null;
      const variantSku = skuElement ? skuElement.textContent.trim() : '';
      const priceEl = root ? root.querySelector('.product-price') : document.querySelector('.product-price');

      let qtyAcrossVariants = 1;
      const step = parseInt(quantityInputs1.getAttribute('step')) || 1;

      function updateTotalPrice() {
        let qty = parseInt(quantityInputs1.value);
        if (isNaN(qty) || qty < 0) qty = 0;
        if (qty === 0) {
          return;
        }
        if (!parentProductId) {
          return;
        }
        spark.calculatePricingForVariant(parentProductId, variantSku, qty, qtyAcrossVariants)
          .then((pricing) => {
            const totalPrice = pricing.totalPrice;
            const currency = pricing.currency || '€';
            if (priceEl) priceEl.textContent = `${currency}${totalPrice.toFixed(2)}`;
          })
          .catch((error) => {
           // console.error('Error calculating pricing:', error);
          });
      }

      quantityInputs1.addEventListener('input', function () {
        let currentQuantity = parseInt(quantityInputs1.value);
        if (isNaN(currentQuantity) || currentQuantity < 0) currentQuantity = 0;

        // step correction
        if (currentQuantity % step !== 0) {
          currentQuantity = Math.round(currentQuantity / step) * step;
        }

        quantityInputs1.value = currentQuantity;
        updateTotalPrice();
      });

      const buttons = quantityInputs1.closest('.quantity-selector-wrapper')?.querySelectorAll('.btn-quantity-selector') || [];
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          let currentQuantity = parseInt(quantityInputs1.value) || 0;

          if (button.classList.contains('btn-minus')) {
            currentQuantity -= step;
            if (currentQuantity < 0) currentQuantity = 0;
          } else if (button.classList.contains('btn-plus')) {
            currentQuantity += step;
          }

          quantityInputs1.value = currentQuantity;
          updateTotalPrice();
        });
      });

      // initial price update
      updateTotalPrice();
    });
  }
}, 200);
  


   // On load change text
         document.addEventListener('DOMContentLoaded', function () {
          const element4 = document.querySelector('.iwishCategoryList a[data-cat="0"]');
          if (element4) {
            element4.textContent = "Standaard";
          }
        });

    // document.addEventListener('DOMContentLoaded', function () {
    //    const elements5 = document.querySelector('.iwishCategoryList .show_more');
    //     if (elements5) {
    //         elements5.textContent = "Bekijk meer ";
    //     }
    // });
    // document.addEventListener('DOMContentLoaded', function () {
    //    const elements5 = document.querySelector('.iwishCategoryList .show_more');
    //     if (elements5) {
    //         elements5.textContent = "Bekijk meer ";
    //       }
    // });
 

   document.addEventListener('DOMContentLoaded', function () {
      const elements3 = document.querySelector('.iwishCategoryDeleteForm button[type="submit"]')
        if (elements3) {
        elements3.textContent = "Verwijder lijst";
       }
     })
     document.addEventListener('DOMContentLoaded', function() {
        const modifyBtn = document.querySelector('.iwishCategoryModifyBtn');
        const modifyForm = document.querySelector('.iwishCategoryModifyForm');
        const closeBtn = document.querySelector('.closeBtn');
        const deleteBtn = document.querySelector('.iwishCategoryDeleteBtn');
        const deleteForm = document.querySelector('.iwishCategoryDeleteForm');
        const closeBtns = document.querySelector('.closeBtns');
        
        if (modifyBtn && modifyForm) {
          modifyBtn.addEventListener('click', function(event) {
            event.preventDefault();
            this.classList.remove('active');
            modifyForm.style.display = 'block';
          });
        }
      
        if (closeBtn && modifyForm) {
          closeBtn.addEventListener('click', function() {
            modifyForm.style.display = 'none';
          });
        }
      
        if (deleteBtn && deleteForm) {
          deleteBtn.addEventListener('click', function(event) {
            event.preventDefault();
            this.classList.remove('active');
            deleteForm.style.display = 'block';
          });
        }
      
        if (closeBtns && deleteForm) {
          closeBtns.addEventListener('click', function() {
            deleteForm.style.display = 'none';
          });
        }
      });
      

  // qunitity reset to zero 
document.addEventListener('DOMContentLoaded', () => {

  const setBtn = document.getElementById('set-quantities-button');
  if (!setBtn) return;

  setBtn.addEventListener('click', () => {
    let wishlistData = JSON.parse(localStorage.getItem("iwish_list")) || [];
    document.querySelectorAll('.iwishItem').forEach(item => {
      const inputs = item.querySelectorAll('.input-quantity');
      const hidden = item.querySelector('.iwishQtyInput');
      if (!inputs.length || !hidden) return;
      const variantId = hidden.getAttribute("data-variant");
      // UI reset
      inputs.forEach(input => input.value = "0");
      hidden.value = "0";
      // LOCALSTORAGE reset
      const idx = wishlistData.findIndex(([id]) => id == variantId);
      if (idx > -1) {
        wishlistData[idx][1] = 0;
      } else {
        wishlistData.push([variantId, 0]);
      }
    });
    localStorage.setItem("iwish_list", JSON.stringify(wishlistData));
    //console.log("Reset aantallen: quantities permanently set to 0");
  });
});

// function iWishPageinitFn(){
//   const wishlistTop = document.querySelector('.iwishContainer, .iwishWrapper, .iwishList');
//   console.log(wishlistTop, 'wishlisttop')
//   if (!wishlistTop) {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     return;
//   }
//   wishlistTop.scrollIntoView({
//     behavior: 'smooth',
//     block: 'start'
//   });
// } 
// Use event delegation for dynamically loaded pagination
document.addEventListener("click", function(e) {
  const target = e.target.closest(".iwishPagination .pagination a");
  if (!target) return; 
  window.scrollTo({ top: 0, behavior: "smooth" });
});

